import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import Box from '@mui/material/Box';
import React from 'react';
import { appTheme } from '../theme';
import { AnimateIn } from './animate-in';

export function BackToTop(props: {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  // Display full width without spacing for left side navigation
  fullWidth?: boolean;
}) {
  return (
    <Box
      sx={{
        position: 'fixed',
        left: { xs: 15, md: props.fullWidth ? 15 : appTheme.drawerWidth + 15 },
        bottom: { xs: 15, md: 15 },
        zIndex: 1102,
      }}
    >
      <AnimateIn to="top" pixels={10}>
        <Box
          component="button"
          aria-label="back to top"
          style={{
            backgroundColor: '#fff',
            cursor: 'pointer',
            height: 45,
            width: 45,
            borderRadius: 50,
            border: '1px solid #b1b1b1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={props.onClick}
        >
          <ArrowCircleUpIcon fontSize="large" color="primary" />
        </Box>
      </AnimateIn>
    </Box>
  );
}
